"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarDivider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var BAR_DIVIDER = "mx-3 my-2 w-px bg-gray-200";
var BarDivider = function (_a) {
    var className = _a.className;
    return ((0, jsx_runtime_1.jsx)("span", { className: (0, clsx_1.default)(BAR_DIVIDER, className) }, void 0));
};
exports.BarDivider = BarDivider;
